export default __webpack_public_path__ + "static/media/club.b304d887.jpg";